"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectDropdown = void 0;
var _react = require("react");
var _Popover = _interopRequireDefault(require("../Popover"));
var _SelectDropdownMenu = _interopRequireDefault(require("./SelectDropdownMenu"));
var _MenuList = _interopRequireDefault(require("./MenuList"));
var _SelectDropdownErrorBoundary = require("./SelectDropdownErrorBoundary");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EMPTY_SELECTED_OPTIONS = [];
var SelectDropdown = exports.SelectDropdown = function SelectDropdown(_ref) {
  var open = _ref.open,
    options = _ref.options,
    filterOption = _ref.filterOption,
    value = _ref.value,
    _ref$selectedOptions = _ref.selectedOptions,
    selectedOptions = _ref$selectedOptions === void 0 ? EMPTY_SELECTED_OPTIONS : _ref$selectedOptions,
    withSelectAll = _ref.withSelectAll,
    markSelectedOption = _ref.markSelectedOption,
    displayNode = _ref.displayNode,
    onClose = _ref.onClose,
    onChange = _ref.onChange,
    _ref$rowHeight = _ref.rowHeight,
    rowHeight = _ref$rowHeight === void 0 ? 40 : _ref$rowHeight,
    _ref$groupHeight = _ref.groupHeight,
    groupHeight = _ref$groupHeight === void 0 ? 40 : _ref$groupHeight,
    width = _ref.width,
    _ref$anchorOrigin = _ref.anchorOrigin,
    anchorOrigin = _ref$anchorOrigin === void 0 ? {
      vertical: 'bottom',
      horizontal: 'left'
    } : _ref$anchorOrigin,
    _ref$transformOrigin = _ref.transformOrigin,
    transformOrigin = _ref$transformOrigin === void 0 ? {
      vertical: 'top',
      horizontal: 'left'
    } : _ref$transformOrigin,
    PopoverProps = _ref.PopoverProps,
    MenuProps = _ref.MenuProps,
    withFilter = _ref.withFilter,
    disabled = _ref.disabled,
    renderOption = _ref.renderOption,
    renderGroup = _ref.renderGroup,
    withDeselectButton = _ref.withDeselectButton,
    searchExp = _ref.searchExp,
    _ref$MenuComponent = _ref.MenuComponent,
    MenuComponent = _ref$MenuComponent === void 0 ? _SelectDropdownMenu["default"] : _ref$MenuComponent,
    _ref$MenuListComponen = _ref.MenuListComponent,
    MenuListComponent = _ref$MenuListComponen === void 0 ? _MenuList["default"] : _ref$MenuListComponen,
    canDeselect = _ref.canDeselect,
    isOptionDisabled = _ref.isOptionDisabled,
    onAdd = _ref.onAdd,
    addOptionLabel = _ref.addOptionLabel,
    groupBy = _ref.groupBy,
    onDropdownFocus = _ref.onDropdownFocus,
    disableAutoFocus = _ref.disableAutoFocus,
    disableEnforceFocus = _ref.disableEnforceFocus,
    favorits = _ref.favorits,
    favoritsLabel = _ref.favoritsLabel,
    multiple = _ref.multiple,
    hideSelectedOption = _ref.hideSelectedOption,
    firstSelected = _ref.firstSelected,
    loading = _ref.loading,
    fetching = _ref.fetching,
    onSearch = _ref.onSearch,
    minOptionCountForSearch = _ref.minOptionCountForSearch,
    isServerSideMode = _ref.isServerSideMode,
    isServerSideInitScreen = _ref.isServerSideInitScreen,
    inputPlaceholder = _ref.inputPlaceholder,
    getOptionValue = _ref.getOptionValue;
  var calcWithSelectAll = (0, _react.useMemo)(function () {
    if (isServerSideInitScreen) {
      return false;
    }
    return withSelectAll;
  }, [isServerSideInitScreen, withSelectAll]);
  var calcWithDeselectButton = (0, _react.useMemo)(function () {
    if (isServerSideInitScreen) {
      if (multiple) {
        return (value === null || value === void 0 ? void 0 : value.length) > 0;
      }
      return true;
    }
    return withDeselectButton;
  }, [isServerSideInitScreen, multiple, value, withDeselectButton]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectDropdownErrorBoundary.SelectDropdownErrorBoundary, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Popover["default"], _objectSpread(_objectSpread({
      open: open,
      onClose: onClose,
      anchorEl: displayNode,
      anchorOrigin: anchorOrigin,
      transformOrigin: transformOrigin
    }, PopoverProps), {}, {
      onFocus: function onFocus() {
        if (onDropdownFocus) {
          onDropdownFocus();
        }
      },
      disableAutoFocus: disableAutoFocus,
      disableEnforceFocus: disableEnforceFocus,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuComponent, _objectSpread(_objectSpread({}, MenuProps), {}, {
        width: width,
        selectedOptions: selectedOptions,
        renderOption: renderOption,
        renderGroup: renderGroup,
        options: options,
        disabled: disabled,
        rowHeight: rowHeight,
        groupHeight: groupHeight,
        filterOption: filterOption,
        onChange: onChange,
        withFilter: withFilter,
        withSelectAll: calcWithSelectAll,
        searchExp: searchExp,
        markSelectedOption: markSelectedOption,
        canDeselect: canDeselect,
        withDeselectButton: calcWithDeselectButton,
        MenuListComponent: MenuListComponent,
        isOptionDisabled: isOptionDisabled,
        onAdd: onAdd,
        addOptionLabel: addOptionLabel,
        onCloseDropdown: onClose,
        groupBy: groupBy,
        favorits: favorits,
        favoritsLabel: favoritsLabel,
        multiple: multiple,
        hideSelectedOption: hideSelectedOption,
        firstSelected: firstSelected,
        isServerSideInitScreen: isServerSideInitScreen,
        onSearch: onSearch,
        minOptionCountForSearch: minOptionCountForSearch,
        loading: loading,
        fetching: fetching,
        isServerSideMode: isServerSideMode,
        inputPlaceholder: inputPlaceholder,
        getOptionValue: getOptionValue
      }))
    }))
  });
};